import { CommonModule } from '@angular/common';
import { IonicModule, ModalController } from '@ionic/angular';
import { EmptyPageModule } from './../../../empty-page/empty-page.module';
import { Team } from './../../models/team.model';
import { TeamItemComponentModule } from './../../../my-teams/team-item/team-item.module';
import { SearchTeamsComponent } from './../search-teams/search-teams.component';
import { Component, inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ThemeService } from '../../../_core/services/theme.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-search-team-list',
  templateUrl: './search-team-list.component.html',
  styleUrls: ['./search-team-list.component.scss'],
  standalone: true,
  imports: [
    SearchTeamsComponent,
    TeamItemComponentModule,
    EmptyPageModule,
    IonicModule,
    CommonModule
  ]
})
export class SearchTeamListComponent implements OnInit {
  teams: Team[];
  private router = inject(Router);
  themeService = inject(ThemeService);
  private translateService = inject(TranslateService);
  
  @Input({required: false}) iaItaResultsPage: boolean = false;
  @Input({required: false}) emptyPagePlaceholder: string = '';

  constructor(
    private modalController: ModalController,
  ) { }

  ngOnInit() {
    // Set default placeholder text using translation service
    if (!this.emptyPagePlaceholder) {
      this.emptyPagePlaceholder = this.translateService.instant('Search teams to show results');
    }
  }

  searchedTeams(teams: Team[]) {
    this.teams = teams;
  }

  async close(team?) {
    await this.modalController.dismiss(team);
    if(this.iaItaResultsPage && team?._id){
        this.router?.navigate(['/my-teams', team._id, 'schedule']);
    }
  }

}
